import { render, staticRenderFns } from "./carportPackageList.vue?vue&type=template&id=56e9adc6&"
import script from "./carportPackageList.vue?vue&type=script&lang=js&"
export * from "./carportPackageList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports